import { strapiRepository } from "~/strapi/strapiRepository";
import { staticFunctionMiddleware } from "@tanstack/start-static-server-functions";
import { components } from "src/strapi/schema";
import { StrapiRepository } from "src/strapi/strapiRepository";
import { referencesDefaultSort } from "./helpers";
import { createServerFn } from "@tanstack/react-start";

export const getNavbarItemsServerFn = createServerFn({ method: "GET" })
  .middleware([staticFunctionMiddleware])
  .handler(async () => {
    const navbar = await strapiRepository.getNavbarItems();
    return navbar;
  });

export const getHomepageServerFn = createServerFn({ method: "GET" })
  .middleware([staticFunctionMiddleware])
  .handler(async () => {
    const homepage = await strapiRepository.getHomepage();
    return homepage;
  });

export const getReferencesServerFn = createServerFn({ method: "GET" })
  .middleware([staticFunctionMiddleware])
  .inputValidator((data: Record<string, any>) => data)
  .handler(async ({ data }) => {
    const references = await strapiRepository.getReferences(data);
    return references;
  });

export const getFinishedReferencesServerFn = createServerFn({ method: "GET" })
  .middleware([staticFunctionMiddleware])
  .inputValidator((data?: { categorySlug?: string }) => data)
  .handler(async ({ data }) => {
    const filter = {
      filters: {
        $and: [
          {
            [`${"isFinished" satisfies keyof components["schemas"]["Reference"]}`]:
              {
                $eq: true,
              },
          },
        ],
      },
      sort: referencesDefaultSort,
    } as NonNullable<Parameters<StrapiRepository["getReferences"]>[0]>;

    if (data?.categorySlug) {
      filter.filters.$and.push({
        [`${"categories" satisfies keyof components["schemas"]["Reference"]}`]:
          {
            [`${"slug" satisfies keyof components["schemas"]["Category"]}`]: {
              $contains: data?.categorySlug,
            },
          },
      });
    }

    const references = await strapiRepository.getReferences(filter);
    return references;
  });

export const getReferenceBySlugServerFn = createServerFn({ method: "GET" })
  .middleware([staticFunctionMiddleware])
  .inputValidator((data: { slug: string }) => data)
  .handler(async ({ data }) => {
    const reference = await strapiRepository.getReferenceBySlug(data.slug);
    return reference;
  });

export const getCategoriesWithReferencesServerFn = createServerFn({
  method: "GET",
})
  .middleware([staticFunctionMiddleware])
  .handler(async () => {
    const categories = await strapiRepository.getCategoriesWithReferences();
    return categories;
  });

export const getContactsServerFn = createServerFn({ method: "GET" })
  .middleware([staticFunctionMiddleware])
  .handler(async () => {
    const contacts = await strapiRepository.getContacts();
    return contacts;
  });

export const getServicesServerFn = createServerFn({ method: "GET" })
  .middleware([staticFunctionMiddleware])
  .handler(async () => {
    const services = await strapiRepository.getServices();
    return services;
  });

export const getCategoryBySlugServerFn = createServerFn({ method: "GET" })
  .middleware([staticFunctionMiddleware])
  .inputValidator((data: { slug: string }) => data)
  .handler(async ({ data }) => {
    const category = await strapiRepository.getCategoryBySlug(data.slug);
    return category;
  });

export const getPageBySlugServerFn = createServerFn({ method: "GET" })
  .middleware([staticFunctionMiddleware])
  .inputValidator((data: { slug: string }) => data)
  .handler(async ({ data }) => {
    const page = await strapiRepository.getPageBySlug(data.slug);
    return page;
  });
